import { createSlice } from "@reduxjs/toolkit";

export const BoostedOddsConfigSlice = createSlice({
    name: "BoostedOddsConfigSlice",
    initialState: {
        persistedFormData: {},
        configList: [],
        configPaginationFirstValue: 1,
        configPaginationSecondValue: 25,
        configRecordsShow: [1, 25],
        configIsVisible: false,
        historyFilters: {
            startDate: null,
            endDate: null,
            status: "ACTIVE",
            customerId: "",
        },
        historyList: [],
        historyTotalRecords: 0,
        historyPaginationFirstValue: 1,
        historyPaginationSecondValue: 25,
        historyRecordsShow: [1, 25],
        historyIsVisible: false,
    },
    reducers: {
        setPersistedFormData: (state, action) => {
            state.persistedFormData = action.payload
        },
        setConfigList: (state, action) => {
            state.configList = action.payload
        },
        setConfigPaginationFirstValue: (state, action) => {
            state.configPaginationFirstValue = action.payload
        },
        setConfigPaginationSecondValue: (state, action) => {
            state.configPaginationSecondValue = action.payload
        },
        setConfigRecordsShow: (state, action) => {
            state.configRecordsShow = action.payload
        },
        setConfigIsVisible: (state, action) => {
            state.configIsVisible = action.payload
        },
        setHistoryFilters: (state, action) => {
            state.historyFilters = action.payload
        },
        setHistoryList: (state, action) => {
            state.historyList = action.payload
        },
        setHistoryTotalRecords: (state, action) => {
            state.historyTotalRecords = action.payload
        },
        setHistoryPaginationFirstValue: (state, action) => {
            state.historyPaginationFirstValue = action.payload
        },
        setHistoryPaginationSecondValue: (state, action) => {
            state.historyPaginationSecondValue = action.payload
        },
        setHistoryRecordsShow: (state, action) => {
            state.historyRecordsShow = action.payload
        },
        setHistoryIsVisible: (state, action) => {
            state.historyIsVisible = action.payload
        },
    },
})

export const {
    setPersistedFormData,
    setConfigList,
    setConfigPaginationFirstValue,
    setConfigPaginationSecondValue,
    setConfigRecordsShow,
    setConfigIsVisible,
    setHistoryFilters,
    setHistoryList,
    setHistoryTotalRecords,
    setHistoryPaginationFirstValue,
    setHistoryPaginationSecondValue,
    setHistoryRecordsShow,
    setHistoryIsVisible,
} = BoostedOddsConfigSlice.actions

export default BoostedOddsConfigSlice.reducer
